import React, { useState, useEffect } from 'react';
import './PayrollTable.css';

const API = '/api/payroll';

export default function Accountant() {
  const [dateFrom, setDateFrom]     = useState('');
  const [dateTo, setDateTo]         = useState('');
  const [uploading, setUploading]   = useState(false);
  const [applying, setApplying]     = useState(false);
  const [uploadData, setUploadData] = useState(null);
  const [history, setHistory]       = useState([]);
  const [employees, setEmployees]   = useState([]);

  useEffect(() => {
    loadHistory();
    fetch(`${API}/employees`).then(r => r.json()).then(d => setEmployees(Array.isArray(d) ? d : []));
  }, []);

  async function loadHistory() {
    const data = await fetch(`${API}/logs?entity=adjustment&action=CREATE&limit=20`).then(r => r.json());
    setHistory(Array.isArray(data) ? data.filter(l => l.description?.includes('бухгалтера')) : []);
  }

  async function uploadFile(file) {
    if (!dateFrom || !dateTo) { alert('Укажите период'); return; }
    setUploading(true);
    setUploadData(null);
    const formData = new FormData();
    formData.append('file', file);
    try {
      const res = await fetch(`${API}/accountant/upload-global?date_from=${dateFrom}&date_to=${dateTo}`, {
        method: 'POST',
        body: formData,
      });
      const data = await res.json();
      setUploadData(data.parsed || []);
    } catch(e) {
      alert('Ошибка: ' + e.message);
    }
    setUploading(false);
  }

  async function applyAdvances() {
    if (!uploadData) return;
    setApplying(true);
    const toApply = uploadData.filter(d => d.matched_id && d.apply !== false);
    await fetch(`${API}/accountant/apply-global?date_from=${dateFrom}&date_to=${dateTo}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(toApply),
    });
    setUploadData(null);
    setApplying(false);
    loadHistory();
    alert(`✅ Применено: ${toApply.length} авансов`);
  }

  const matched = uploadData ? uploadData.filter(d => d.matched_id) : [];
  const toApply = uploadData ? uploadData.filter(d => d.matched_id && d.apply !== false) : [];

  const [exportFrom, setExportFrom] = useState('');
  const [exportTo, setExportTo]     = useState('');

  return (
    <div className="pt-page">
      <div className="pt-header">
        <h2>Файл бухгалтера</h2>
      </div>

      {/* Выгрузка утверждённых ведомостей */}
      <div style={{ background:'#fff', borderRadius:12, padding:20, boxShadow:'0 1px 3px rgba(0,0,0,0.08)', marginBottom:24 }}>
        <h3 style={{ margin:'0 0 16px', fontSize:15, fontWeight:600 }}>📊 Выгрузка утверждённых ведомостей</h3>
        <div style={{ display:'flex', gap:12, alignItems:'center', flexWrap:'wrap' }}>
          <div>
            <label style={{ fontSize:12, color:'#6b7280', display:'block', marginBottom:4 }}>Период с</label>
            <input type="date" value={exportFrom} onChange={e => setExportFrom(e.target.value)}
              style={{ padding:'8px 12px', border:'1px solid #e5e7eb', borderRadius:8, fontSize:14 }} />
          </div>
          <div>
            <label style={{ fontSize:12, color:'#6b7280', display:'block', marginBottom:4 }}>Период по</label>
            <input type="date" value={exportTo} onChange={e => setExportTo(e.target.value)}
              style={{ padding:'8px 12px', border:'1px solid #e5e7eb', borderRadius:8, fontSize:14 }} />
          </div>
          <button
            className="btn-primary"
            style={{ marginTop:18 }}
            disabled={!exportFrom || !exportTo}
            onClick={() => window.open(`/api/payroll/export/payroll-excel?date_from=${exportFrom}&date_to=${exportTo}`, '_blank')}
          >
            📥 Выгрузить ведомости
          </button>
        </div>
        <div style={{ fontSize:12, color:'#9ca3af', marginTop:8 }}>
          Выгружаются только ведомости со статусом «Утверждено» или «Оплачено»
        </div>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'420px 1fr', gap:24, marginBottom:24 }}>
        {/* Загрузка */}
        <div style={{ background:'#fff', borderRadius:12, padding:24, boxShadow:'0 1px 3px rgba(0,0,0,0.08)' }}>
          <h3 style={{ margin:'0 0 16px', fontSize:15, fontWeight:600 }}>Загрузить файл</h3>

          <div className="form-grid" style={{ marginBottom:16 }}>
            <div className="form-row">
              <label>Период с *</label>
              <input type="date" value={dateFrom} onChange={e => { setDateFrom(e.target.value); setUploadData(null); }} />
            </div>
            <div className="form-row">
              <label>Период по *</label>
              <input type="date" value={dateTo} onChange={e => { setDateTo(e.target.value); setUploadData(null); }} />
            </div>
          </div>

          <div
            style={{
              border:'2px dashed #e5e7eb', borderRadius:12, padding:32,
              textAlign:'center', cursor: (uploading || !dateFrom || !dateTo) ? 'default' : 'pointer',
              background: uploading ? '#f9fafb' : '#fff', marginBottom:16,
              opacity: (!dateFrom || !dateTo) ? 0.5 : 1
            }}
            onClick={() => !uploading && dateFrom && dateTo && document.getElementById('acc-file').click()}
          >
            {uploading ? (
              <div>
                <div style={{ fontSize:28, marginBottom:8 }}>⏳</div>
                <div style={{ color:'#6b7280', fontWeight:500 }}>ИИ парсит файл...</div>
                <div style={{ color:'#9ca3af', fontSize:12, marginTop:4 }}>10–30 секунд</div>
              </div>
            ) : (
              <div>
                <div style={{ fontSize:32, marginBottom:8 }}>📊</div>
                <div style={{ color:'#374151', fontWeight:500 }}>Нажмите для выбора файла</div>
                <div style={{ color:'#9ca3af', fontSize:12, marginTop:4 }}>Excel (.xlsx)</div>
              </div>
            )}
          </div>

          <input id="acc-file" type="file" accept=".xlsx,.xls" style={{ display:'none' }}
            onChange={e => e.target.files[0] && uploadFile(e.target.files[0])} />

          {uploadData && (
            <div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:8, marginBottom:16 }}>
                <div style={{ textAlign:'center', background:'#f9fafb', borderRadius:8, padding:12 }}>
                  <div style={{ fontSize:24, fontWeight:700 }}>{uploadData.length}</div>
                  <div style={{ fontSize:11, color:'#9ca3af' }}>найдено</div>
                </div>
                <div style={{ textAlign:'center', background:'#d1fae5', borderRadius:8, padding:12 }}>
                  <div style={{ fontSize:24, fontWeight:700, color:'#059669' }}>{matched.length}</div>
                  <div style={{ fontSize:11, color:'#6b7280' }}>сопоставлено</div>
                </div>
                <div style={{ textAlign:'center', background:'#fee2e2', borderRadius:8, padding:12 }}>
                  <div style={{ fontSize:24, fontWeight:700, color:'#dc2626' }}>{uploadData.length - matched.length}</div>
                  <div style={{ fontSize:11, color:'#6b7280' }}>не найдено</div>
                </div>
              </div>
              <button className="btn-primary" style={{ width:'100%' }}
                onClick={applyAdvances} disabled={applying || toApply.length === 0}>
                {applying ? 'Применяем...' : `✅ Применить авансы (${toApply.length})`}
              </button>
            </div>
          )}
        </div>

        {/* История */}
        <div style={{ background:'#fff', borderRadius:12, padding:24, boxShadow:'0 1px 3px rgba(0,0,0,0.08)' }}>
          <h3 style={{ margin:'0 0 16px', fontSize:15, fontWeight:600 }}>История загрузок</h3>
          {history.length === 0 && <div style={{ color:'#9ca3af', fontSize:13 }}>Файлы ещё не загружались</div>}
          {history.map((h, i) => (
            <div key={i} style={{ padding:'10px 0', borderBottom:'1px solid #f3f4f6' }}>
              <div style={{ fontSize:13, color:'#374151' }}>{h.description}</div>
              <div style={{ fontSize:11, color:'#9ca3af', marginTop:3 }}>
                {new Date(h.created_at).toLocaleString('ru')}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Таблица результатов */}
      {uploadData && (
        <div style={{ background:'#fff', borderRadius:12, padding:24, boxShadow:'0 1px 3px rgba(0,0,0,0.08)' }}>
          <h3 style={{ margin:'0 0 16px', fontSize:15, fontWeight:600 }}>
            Результаты сопоставления
          </h3>
          <table className="pt-table">
            <thead>
              <tr><th>В файле</th><th>Сумма ₽</th><th>Сопоставлен с</th><th>Применить</th></tr>
            </thead>
            <tbody>
              {uploadData.map((d, i) => (
                <tr key={i} style={{ opacity: d.apply === false ? 0.5 : 1, background: d.matched_id ? '#fff' : '#fff7f7' }}>
                  <td style={{ color:'#374151', fontSize:13 }}>{d.file_name}</td>
                  <td>
                    <input
                      type="number"
                      value={d.amount || ''}
                      onChange={e => {
                        const nd = [...uploadData];
                        nd[i] = { ...nd[i], amount: parseFloat(e.target.value) || 0 };
                        setUploadData(nd);
                      }}
                      style={{ width:90, padding:'4px 8px', border:'1px solid #e5e7eb', borderRadius:6, fontSize:13, color:'#dc2626', fontWeight:600 }}
                    />
                  </td>
                  <td>
                    <select
                      value={d.matched_id || ''}
                      onChange={e => {
                        const nd = [...uploadData];
                        const emp = employees.find(em => em.id === parseInt(e.target.value));
                        nd[i] = { ...nd[i], matched_id: emp ? emp.id : null, matched_name: emp ? emp.full_name : null, apply: !!emp };
                        setUploadData(nd);
                      }}
                      style={{ width:'100%', padding:'4px 8px', border:'1px solid ' + (d.matched_id ? '#d1fae5' : '#fee2e2'), borderRadius:6, fontSize:12, color: d.matched_id ? '#059669' : '#dc2626', background: d.matched_id ? '#f0fdf4' : '#fff7f7' }}
                    >
                      <option value="">❌ не найден</option>
                      {employees.map(em => (
                        <option key={em.id} value={em.id}>{em.full_name}</option>
                      ))}
                    </select>
                  </td>
                  <td style={{ textAlign:'center' }}>
                    <input type="checkbox"
                      checked={d.apply !== false && !!d.matched_id}
                      disabled={!d.matched_id}
                      onChange={e => {
                        const nd = [...uploadData];
                        nd[i] = { ...nd[i], apply: e.target.checked };
                        setUploadData(nd);
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
